import logo from "../../medias/images/WisdomLogo.png";

function Logo() {
  return <img className="wisdom-logo" src={logo} alt="Wisdom Logo" />;
}

export default Logo;
